module.exports = __webpack_public_path__ + "img/img_game.5780a9c6.png";